"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _SearchResultsSection = _interopRequireDefault(require("./SearchResultsSection"));

var _HitContainerHeader = _interopRequireDefault(require("./HitContainerHeader"));

var _index = require("./index");

var _SearchActionLink = _interopRequireDefault(require("./SearchActionLink"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _SearchBox = require("@insided/deprecated-preact-components/algolia/components/SearchBox");

var _Search = _interopRequireDefault(require("@insided/shared/icons/Search"));

var _Edit = _interopRequireDefault(require("@insided/shared/icons/Edit"));

// We need to keep a record of the offsets of each custom source to display results correctly.
function getUniqueFederatedSources(federatedHits) {
  var sources = Array.from(new Set(federatedHits.map(function (hit) {
    return hit.source;
  })));
  var currentOffset = 0;
  return sources.map(function (source) {
    var sourceHits = federatedHits.filter(function (hit) {
      return hit.source === source;
    }).slice(0, 3);
    var sourceMetadata = [source, sourceHits, currentOffset];
    currentOffset += sourceHits.length;
    return sourceMetadata;
  });
}

function createViewAllUrl(inputValue) {
  var _getInsidedData, _getInsidedData2;

  var searchParams = new URLSearchParams();
  searchParams.set('q', inputValue);
  var categoryPath = (_getInsidedData = (0, _insidedDataStorage.getInsidedData)('search')) === null || _getInsidedData === void 0 ? void 0 : _getInsidedData.categoryPath;
  var moduleName = (_getInsidedData2 = (0, _insidedDataStorage.getInsidedData)('search')) === null || _getInsidedData2 === void 0 ? void 0 : _getInsidedData2.module;

  if (categoryPath && moduleName && Object.keys(_SearchBox.ModuleMappingForSearchFilters).includes(moduleName)) {
    // @ts-expect-error
    searchParams.set(_SearchBox.ModuleMappingForSearchFilters[moduleName], categoryPath);
  }

  return "/search?".concat(searchParams.toString());
}

var HitContainerWithFederated = function HitContainerWithFederated(_ref) {
  var key = _ref.key,
      indexName = _ref.indexName,
      allSearchResults = _ref.allSearchResults,
      inputValue = _ref.inputValue,
      doSearch = _ref.doSearch,
      highlightedIndex = _ref.highlightedIndex,
      showFooterLinks = _ref.showFooterLinks,
      getItemProps = _ref.getItemProps,
      setHighlightedIndex = _ref.setHighlightedIndex,
      style = _ref.style,
      _ref$previousResultsC = _ref.previousResultsCount,
      previousResultsCount = _ref$previousResultsC === void 0 ? 0 : _ref$previousResultsC;
  var communitySearchMetadata;
  var zendeskSearchMetadata;
  var salesforceSearchMetadata;
  var skilljarSearchMetadata;
  var freshdeskSearchMetadata;
  var federatedSearchMetadata;

  if ((0, _index.isMultiIndexResult)(allSearchResults)) {
    communitySearchMetadata = allSearchResults === null || allSearchResults === void 0 ? void 0 : allSearchResults[indexName];
    zendeskSearchMetadata = allSearchResults === null || allSearchResults === void 0 ? void 0 : allSearchResults["".concat(indexName, "-zendesk")];
    salesforceSearchMetadata = allSearchResults === null || allSearchResults === void 0 ? void 0 : allSearchResults["".concat(indexName, "-salesforce")];
    skilljarSearchMetadata = allSearchResults === null || allSearchResults === void 0 ? void 0 : allSearchResults["".concat(indexName, "-skilljar")];
    freshdeskSearchMetadata = allSearchResults === null || allSearchResults === void 0 ? void 0 : allSearchResults["".concat(indexName, "-freshdesk")];
    federatedSearchMetadata = allSearchResults === null || allSearchResults === void 0 ? void 0 : allSearchResults["".concat(indexName, "-federated")];
  } else {
    communitySearchMetadata = allSearchResults !== null && allSearchResults !== void 0 ? allSearchResults : undefined;
  }

  var communityHits = communitySearchMetadata ? communitySearchMetadata.hits : [];
  var zendeskHits = zendeskSearchMetadata ? zendeskSearchMetadata.hits : [];
  var salesforceHits = salesforceSearchMetadata ? salesforceSearchMetadata.hits : [];
  var skilljarHits = skilljarSearchMetadata ? skilljarSearchMetadata.hits : [];
  var freshdeskHits = freshdeskSearchMetadata ? freshdeskSearchMetadata.hits : [];
  var federatedHits = federatedSearchMetadata ? federatedSearchMetadata.hits : [];
  var hasResults = communityHits.length || zendeskHits.length || salesforceHits.length || skilljarHits.length || freshdeskHits.length || federatedHits.length;
  var federatedHitsWithMetadata = getUniqueFederatedSources(federatedHits);
  return (0, _preact.h)("div", {
    key: "".concat(key !== null && key !== void 0 ? key : 'results'),
    className: "algolia-hit-container",
    style: style
  }, (0, _preact.h)(_HitContainerHeader.default, {
    inputValue: inputValue,
    hasResults: !!hasResults,
    doSearch: doSearch
  }), communitySearchMetadata && communityHits ? (0, _preact.h)(_SearchResultsSection.default, {
    title: (0, _index.isMultiIndexResult)(allSearchResults) ? (0, _preact.h)(_phrase.default, {
      p: "nav.title.community"
    }) : '',
    type: "community",
    searchMetadata: communitySearchMetadata,
    hits: communityHits,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    previousResultsCount: previousResultsCount,
    setHighlightedIndex: setHighlightedIndex,
    viewAllUrl: createViewAllUrl(inputValue)
  }) : null, zendeskSearchMetadata && zendeskHits && communityHits ? (0, _preact.h)(_SearchResultsSection.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "federated.search.zendesk"
    }),
    type: "zendesk",
    searchMetadata: zendeskSearchMetadata,
    hits: zendeskHits,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    setHighlightedIndex: setHighlightedIndex,
    previousResultsCount: previousResultsCount + communityHits.length,
    viewAllUrl: "/search?source=zendesk&q=".concat(inputValue)
  }) : null, salesforceSearchMetadata && salesforceHits && communityHits ? (0, _preact.h)(_SearchResultsSection.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "federated.search.salesforce"
    }),
    type: "salesforce",
    searchMetadata: salesforceSearchMetadata,
    hits: salesforceHits,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    setHighlightedIndex: setHighlightedIndex,
    previousResultsCount: previousResultsCount + zendeskHits.length + communityHits.length,
    viewAllUrl: "/search?source=salesforce&q=".concat(inputValue)
  }) : null, skilljarSearchMetadata && skilljarHits && communityHits ? (0, _preact.h)(_SearchResultsSection.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "federated.search.skilljar"
    }),
    type: "skilljar",
    searchMetadata: skilljarSearchMetadata,
    hits: skilljarHits,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    setHighlightedIndex: setHighlightedIndex,
    previousResultsCount: previousResultsCount + salesforceHits.length + zendeskHits.length + communityHits.length,
    viewAllUrl: "/search?source=skilljar&q=".concat(inputValue)
  }) : null, freshdeskSearchMetadata && freshdeskHits && communityHits ? (0, _preact.h)(_SearchResultsSection.default, {
    title: (0, _preact.h)(_phrase.default, {
      p: "federated.search.freshdesk"
    }),
    type: "freshdesk",
    searchMetadata: freshdeskSearchMetadata,
    hits: freshdeskHits,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    setHighlightedIndex: setHighlightedIndex,
    previousResultsCount: previousResultsCount + skilljarHits.length + salesforceHits.length + zendeskHits.length + communityHits.length,
    viewAllUrl: "/search?source=freshdesk&q=".concat(inputValue)
  }) : null, federatedSearchMetadata && federatedHits && communityHits ? federatedHitsWithMetadata.map(function (_ref2) {
    var _federatedSearchMetad, _federatedSearchMetad2;

    var _ref3 = (0, _slicedToArray2.default)(_ref2, 3),
        source = _ref3[0],
        hits = _ref3[1],
        offset = _ref3[2];

    return (0, _preact.h)(_SearchResultsSection.default, {
      key: source,
      title: (0, _preact.h)(_phrase.default, {
        p: "federated.search.".concat(source)
      }),
      type: "federated",
      searchMetadata: {
        hitsPerPage: 3,
        page: 1,
        queryID: (_federatedSearchMetad = (_federatedSearchMetad2 = federatedSearchMetadata) === null || _federatedSearchMetad2 === void 0 ? void 0 : _federatedSearchMetad2.queryID) !== null && _federatedSearchMetad !== void 0 ? _federatedSearchMetad : ''
      },
      hits: hits,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      setHighlightedIndex: setHighlightedIndex,
      previousResultsCount: previousResultsCount + offset + skilljarHits.length + salesforceHits.length + zendeskHits.length + communityHits.length + freshdeskHits.length,
      viewAllUrl: "/search?source=".concat(source, "&q=").concat(inputValue)
    });
  }) : null, !(0, _index.isMultiIndexResult)(allSearchResults) && showFooterLinks ? (0, _preact.h)(_SearchActionLink.default, {
    icon: (0, _preact.h)(_Search.default, {
      height: 20,
      width: 20
    }),
    href: (0, _absoluteUrlRuntime.resolveUrl)(createViewAllUrl(inputValue)),
    highlightedIndex: highlightedIndex !== null && highlightedIndex !== void 0 ? highlightedIndex : 0,
    previousResultsCount: previousResultsCount + skilljarHits.length + salesforceHits.length + zendeskHits.length + communityHits.length + freshdeskHits.length + federatedHits.length,
    getItemProps: getItemProps,
    trackType: "click",
    elementName: "Algolia search view all link"
  }, (0, _preact.h)(_phrase.default, {
    p: "live.search.view.all"
  })) : null, showFooterLinks ? (0, _preact.h)(_SearchActionLink.default, {
    icon: (0, _preact.h)(_Edit.default, {
      height: 20,
      width: 20
    }),
    highlightedIndex: highlightedIndex !== null && highlightedIndex !== void 0 ? highlightedIndex : 0,
    previousResultsCount: previousResultsCount + skilljarHits.length + salesforceHits.length + zendeskHits.length + communityHits.length + freshdeskHits.length + federatedHits.length + (!(0, _index.isMultiIndexResult)(allSearchResults) ? 1 : 0),
    getItemProps: getItemProps,
    href: (0, _absoluteUrlRuntime.resolveUrl)("/topic/new"),
    trackType: "click",
    elementName: "Algolia search ask question link"
  }, (0, _preact.h)(_phrase.default, {
    p: "live.search.ask.question"
  })) : null);
};

var _default = HitContainerWithFederated;
exports.default = _default;